var mapModals = {
  confirmDeleteDrawing: function(translations) {
    var modal;

    modal =   '<div class="modal" id="confirmDeleteDrawingModal" tabindex="-1">';
    modal +=    '<div class="modal-dialog modal-sm c-modal">';
    modal +=      '<div class="c-modal__header">';
    modal +=        '<div class="t-title--large">';
    modal +=          translations.delete_shape;
    modal +=        '</div>';
    modal +=      '</div>'
    modal +=      '<div class="c-modal__content">';
    modal +=          translations.discard_warning_message;
    modal +=      '</div>';
    modal +=      '<div class="c-modal__footer">';
    modal +=        '<button type="button" id="cancelDeleteDrawingBtn" class="btn btn-tertiary" data-dismiss="modal">';
    modal +=          translations.cancel;
    modal +=        '</button>';
    modal +=        '<button type="button" id="deleteDrawingBtn" class="btn btn-primary" data-dismiss="modal">';
    modal +=          translations.yes_im_sure;
    modal +=        '</button>';
    modal +=      '</div>';
    modal +=    '</div>';
    modal +=  '</div>';

    return modal;
  },

  drawnShapeManagementMenu: function(translations) {
    var modal;

    modal =
    `<div id="drawnShapeManagementMenu" class="shape-context-menu context-menu" data-controller="drawn-shape" data-action="focusin->drawn-shape#activateTimeShield">
      <input id="drawnShapeCondition" type="hidden">
      <ul style="list-style-type: none; padding: 0 8px; margin: 0;">
        <li class="shape-context-menu-list-item">
          <div class="form-group">
            <label for="drawnShapeName">Shape Name</label>
            <input class="form-control" id="drawnShapeName" type="text" placeholder="Shape Name" data-action="blur->drawn-shape#changeName">
         </div>
        </li>

        <li class="shape-context-menu-list-item">
          <div class="form-group">
            <label for="drawnShapeColor">Shape Color</label>
            <div id="drawnShapeColor" class="selected-color-outer" data-action="click->drawn-shape#toggleColorSelection keydown.enter->drawn-shape#toggleColorSelection" tabindex="0" role="button">
              <div class="selected-color-inner" data-color="#000000"></div>
              <span class="flexicon flexicon-chevron--small flexicon-90 drawnShapeColorToggle"></span>
            </div>
            <div id="colorChoices" class="hidden" style="padding: 4px; left: 0px; top: 0px">
              <label style="margin-left: 8px;">Select A Color</label>
              <div>
                <div style="display: flex;">
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#0069ff">
                    <div class="color-choice-inner" style="background: #0069ff;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#006600">
                    <div class="color-choice-inner" style="background: #006600;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#4a0000">
                    <div class="color-choice-inner" style="background: #4a0000;"></div>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#cc0000">
                    <div class="color-choice-inner" style="background: #cc0000;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#ffff00">
                    <div class="color-choice-inner" style="background: #ffff00;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#cc6600">
                    <div class="color-choice-inner" style="background: #cc6600;"></div>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#000000">
                    <div class="color-choice-inner" style="background: #000000;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#ff00ff">
                    <div class="color-choice-inner" style="background: #ff00ff;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#00ffff">
                    <div class="color-choice-inner" style="background: #00ffff;"></div>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#00cc00">
                    <div class="color-choice-inner" style="background: #00cc00;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#ff3399">
                    <div class="color-choice-inner" style="background: #ff3399;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#toggleColorSelection" style="display: flex; justify-content: center; align-items: center;" title="Close Color Selector">
                    <span class="flexicon flexicon-close--large" style="color: #0077d9"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="shape-context-menu-list-item">
          <a href="#" id="shapeMenuEditShape" class="shape-context-menu-item" data-action="click->drawn-shape#editShape"> Edit Shape </a>
        </li>
        <li class="shape-context-menu-list-item">
          <a href="#" id="shapeMenuAddToOverlay" class="shape-context-menu-item" data-turbo="false" data-action="click->drawn-shape#addToOverlay"> Add Polygon to Overlay </a>
        </li>
        <li class="shape-context-menu-list-item">
          <a href="#" id="shapeMenuDeleteShape" class="shape-context-menu-item"> Delete Shape </a>
        </li>
      </ul>
    </div>`

    return modal;
  },

  addOverlayModal: function(hiddenInputs, polygonCount, formGroups) {
    let modal = `
      <div id="dialog-save-as-overlay">
        <div class="t-title">Overlay Type</div>
        <input type="hidden" name="cmd" value="srv+srch_rs/saveMapOverlay.json">
        <input type="hidden" name="command_line_mode" value="true">
        ${hiddenInputs}
        <input type="hidden" name="polyCount" value="${polygonCount}">
        <div class="form-group">
          <fieldset>
            <div class="c-segment" data-action="change->overlay-editor-modal#changeOverlayType">
              <input class="c-segment__input" id="overlayNew" name="overlay" type="radio" value="New" data-overlay-editor-modal-target="newOverlayRadio" checked>
              <label class="c-segment__label" for="overlayNew">New Overlay</label>
              <input class="c-segment__input" id="overlayExisting" name="overlay" type="radio" value="Existing" data-overlay-editor-modal-target="existingOverlayRadio">
              <label class="c-segment__label" for="overlayExisting">Existing Overlay</label>
            </div>
          </fieldset>
        </div>
        <div class="c-section__separator" style="margin: 16px 0"></div>
        <div class="form-group hidden" id="modal_overlays_list" data-overlay-editor-modal-target="overlayList">
          <label class="t-title" for="modal_overlays_select">Overlay List</label>
          <select class="form-control" name="modal_overlays_select" id="modal_overlays_select" size="4" style="width:100%;" data-overlay-editor-modal-target="overlaySelect"></select>
        </div>
        <div class="form-group" id="modal_overlay_name"  data-action="focusin->overlay-editor-modal#activateTimeShield blur->overlay-editor-modal#activateTimeShield" data-overlay-editor-modal-target="overlayName">
          <label class="t-title" for="modal_overlay_name">Overlay Name</label>
          <input class="form-control" type="text" name="modal_overlay_name" id="modal_overlay_name" value="" maxlength="40" data-overlay-editor-modal-target="overlayNameInput" data-action="input->overlay-editor-modal#validate">
        </div>
        <div class="form-group">
          <input type="checkbox" id="publicOverlay" value="Y" data-overlay-editor-modal-target="publicOverlayCheckbox">
          <label for="checkbox-checked">Public Overlay</label>
        </div>
        <div class="t-title">Polygons</div>
        <div style="max-height: 250px; overflow-y: auto; padding-right: 10px; border: 1px solid #ccc; border-radius: 5px; padding: 10px;">
          ${formGroups}
        <div>
      </div>`;
    return modal;
  },

  overlayModalButtons: function() {
    let buttons = '<button class="btn btn-secondary" data-dismiss="modal" type="button">Cancel</button><button disabled id="btnSaveOverlay" data-action="click->overlay-editor-modal#saveOverlay" class="btn btn-primary" type="button" data-overlay-editor-modal-target="saveButton">Save</button>';
    return buttons;
  }
}

export default mapModals;
